import * as preact from "preact";

import readlangClient from "readlangClient";
import * as sharedConfig from "shared/sharedConfig";
import stores from "stores/stores";

interface Props {
  bookID: string;
  onDeleteAudio?: () => void;
}

interface State {
  durationText?: string;
  errorText?: string;
  loading: boolean;
  storageUsageText?: string;
}

const formatDuration = (seconds: number) => {
  const totalMinutes = Math.round(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours >= 1) {
    return `${hours} hour${hours !== 1 ? "s" : ""}${
      minutes > 0 ? ` ${minutes} minute${minutes !== 1 ? "s" : ""}` : ""
    }`;
  }
  return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
};

class AudioModal extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {
    this.loadAudioInfo();
  }

  private loadAudioInfo = async () => {
    try {
      const { data: audioInfo } = await readlangClient.request(
        "GET",
        `/api/book/${this.props.bookID}/audioInfo`,
        {}
      );

      const plan = stores.user.state.value.subscriptionPlan ?? "";
      const limitSeconds = /plus|freeForever/.test(plan)
        ? sharedConfig.audioUploadLimitPremiumPlus
        : sharedConfig.audioUploadLimitPremium;

      this.setState({
        loading: false,
        durationText: formatDuration(audioInfo.durationSeconds),
        storageUsageText: `${formatDuration(audioInfo.totalSeconds)} of ${formatDuration(limitSeconds)}`,
      });
    } catch (_error) {
      this.setState({
        loading: false,
        errorText: "Failed to load audio info.",
      });
    }
  };

  render() {
    const { onDeleteAudio } = this.props;
    const { durationText, errorText, loading, storageUsageText } = this.state;

    if (loading) {
      return (
        <div class="audioModal">
          <p>Loading audio info...</p>
        </div>
      );
    }

    if (errorText) {
      return (
        <div class="audioModal">
          <p>{errorText}</p>
        </div>
      );
    }

    return (
      <div class="audioModal">
        <p id="audioFileDuration">
          {durationText && (
            <>
              <strong>This text's audio:</strong> {durationText}
            </>
          )}
        </p>
        <p id="audioStorageUsage">
          {storageUsageText && (
            <>
              <strong>Total storage used:</strong> {storageUsageText}
            </>
          )}
        </p>
        <hr class="audioDivider" />
        <p id="deleteAudioHint">
          Delete the audio to free up storage. The text transcript will remain.
        </p>
        <button id="deleteAudioButton" class="button" onClick={onDeleteAudio}>
          Delete Audio
        </button>
      </div>
    );
  }
}

export default AudioModal;
